export const home = {
  // Hero Section
  heroTitle: '우주적 사고로\n미래를 준비하다',
  heroSubtitle: '탐험하는 배움이 실제 역량으로 이어지는 혁신적 교육 경험',
  heroDescription: 'ICAN은 우주과학과 기술을 통해 학생들의 창의적 사고와 문제해결 능력을 키우는 미래형 교육 프로그램을 제공합니다.',
  
  // Why Space Section
  whySpaceTitle: '왜 우주교육인가?',
  whySpaceSubtitle: '우주는 모든 학문이 융합되는 최고의 학습 환경입니다',
  
  // 스페이스 오리엔티어링 Learning Experience
  learningTitle: '학습 경험',
  learningSubtitle: '실제 우주 미션을 통한 체험형 학습',
  
  // Competencies
  competenciesTitle: '핵심 역량',
  competenciesSubtitle: '미래 사회가 요구하는 필수 능력을 기릅니다',
  
  // Signature Projects
  projectsTitle: '시그니처 프로젝트',
  projectsSubtitle: '실제 우주 기술을 활용한 프로젝트 기반 학습',
  
  // Curriculum
  curriculumTitle: '커리큘럼',
  curriculumSubtitle: '체계적이고 단계적인 학습 과정',
  
  // CTA Section
  ctaTitle: '우주로의 여행을 시작하세요',
  ctaSubtitle: '지금 바로 상담을 신청하고 특별한 교육 경험을 만나보세요',
  ctaButton: '무료 상담 신청',
  
  // Consultation Form
  consultationTitle: '상담 신청',
  consultationSubtitle: '전문 상담사가 맞춤형 교육 과정을 안내해드립니다',
  
  // Programs list
  satelliteDataLiteracy: '위성데이터 리터러시',
  roverDesignSprint: '로버 디자인 스프린트',
  spaceEconomySimulation: '우주 경제 시뮬레이션',
  spaceStationEcosystem: '우주정거장 생태계',
  customCurriculum: '맞춤형 커리큘럼',
  
  // Support list
  learningGuide: '학습 가이드',
  parentReviews: '학부모 리뷰',
  faq: 'FAQ',
  technicalSupport: '기술 지원',
  
  // Curriculum Section
  curriculumModuleTitle: '커리큘럼 <span>모듈</span>',
  curriculumModuleSubtitle: '체계적인 단계별 학습으로 우주적 사고력을 완성합니다',
  
  // Module 1
  module1Title: '위성데이터 리터러시',
  module1Subtitle: 'Satellite Data Literacy',
  module1Description: '기초 통계·시각화로 기후 패턴 분석',
  module1Duration: '4주',
  module1Level: '초급',
  module1Topic1: '위성 데이터 수집',
  module1Topic2: '통계 분석 기초',
  module1Topic3: '데이터 시각화',
  module1Topic4: '기후 패턴 해석',
  
  // Module 2
  module2Title: '로버 디자인 스프린트',
  module2Subtitle: 'Rover Design Sprint',
  module2Description: '문제정의–아이디어–프로토타입–테스트',
  module2Duration: '6주',
  module2Level: '중급',
  module2Topic1: '문제 정의',
  module2Topic2: '아이디어 발상',
  module2Topic3: '프로토타입 제작',
  module2Topic4: '성능 테스트',
  
  // Module 3
  module3Title: '우주 경제 시뮬레이션',
  module3Subtitle: 'Space Economy Simulation',
  module3Description: '데이터 모델링과 스토리텔링 피치',
  module3Duration: '6주',
  module3Level: '고급',
  module3Topic1: '경제 모델링',
  module3Topic2: '시뮬레이션 설계',
  module3Topic3: '데이터 분석',
  module3Topic4: '비즈니스 피치',
  
  // Module buttons
  moduleDetailButton: '모듈 상세보기',
  
  // Learning Path
  learningPathTitle: '학습 경로',
  learningPathSubtitle: '개인별 수준과 관심사에 맞는 맞춤형 학습 경로를 제공합니다',
  learningPathStep1Title: '레벨 진단',
  learningPathStep1Desc: '언어·수리·디지털 역량 사전 평가',
  learningPathStep2Title: '맞춤 경로',
  learningPathStep2Desc: '개인별 수준에 맞는 학습 계획 수립',
  learningPathStep3Title: '성과 인증',
  learningPathStep3Desc: '모듈별 완료 인증서 및 포트폴리오',

  // EDUSPACE Curriculum Section
  eduspaceBadge: 'EDUSPACE 8주 프로그램',
  eduspace8WeekTitle: '8주 완성',
  eduspaceJourneyTitle: '우주 탐사 여정',
  eduspaceSubtitle: '초등 4-5학년을 위한 체계적인 문제해결 프로그램',

  // Weekly highlights
  week1: '지구 과학',
  week1Desc: '지구 시스템과 기후 패턴 탐구',
  week2: '달',
  week2Desc: '달의 위상과 달 기지 설계',
  week3: '우주 탐사 로버',
  week3Desc: '화성 로버 설계 및 제작',
  week4: '화성 탐사',
  week4Desc: '화성 임무 계획 및 생존 전략',
  week5: '우주에서의 생활',
  week5Desc: '우주 생활 시스템 설계',
  week6: '별과 은하',
  week6Desc: '별의 생애와 우주 구조 탐험',
  week7: 'AI와 우주 탐사',
  week7Desc: 'AI로 우주 데이터 분석',
  week8: '최종 프로젝트',
  week8Desc: '종합 우주 임무 발표',

  // Program features
  handsOnTitle: '실습 중심',
  handsOnDesc: '매일 직접 만들고 실험하는 체험형 학습',
  weeklyStructureTitle: '5일 구조',
  weeklyStructureDesc: '월-금 체계적인 주간 학습 프로그램',
  customizedTitle: '맞춤 학습',
  customizedDesc: '초등 4-5학년에 최적화된 난이도',

  // Daily activities
  mondayShort: '월요일',
  mondayActivity: '학습 기술과\n질문하기',
  tuesdayShort: '화요일',
  tuesdayActivity: '탐색과\n리서치',
  wednesdayShort: '수요일',
  wednesdayActivity: '우주와\n문제 해결',
  thursdayShort: '목요일',
  thursdayActivity: '기술과\n제작',
  fridayShort: '금요일',
  fridayActivity: '글쓰기와\n발표',

  viewFullCurriculum: '전체 커리큘럼 보기'
};